/* INTEGY V773 collection view switch: preserve page, sort, stock and theme preview.
   The V577 commerce owner already has a safe DOM-only applyViewMode API.
   Intercept at window capture so older document click handlers cannot navigate. */
(function(){
 'use strict';
 if(!/^\/collections\//i.test(location.pathname))return;
 window.addEventListener('click',function(event){
   var target=event.target;
   var button=target&&target.closest?target.closest('button[data-collection-view]'):null;
   if(!button || !button.closest('main#site-main,.productgrid--outer'))return;
   var view=button.getAttribute('data-collection-view');
   if(view!=='grid-view'&&view!=='list-view')return;
   var owner=window.IntegyV449CommerceOwner;
   if(!owner||typeof owner.applyViewMode!=='function')return;
   event.preventDefault();event.stopImmediatePropagation();
   // No navigation: retaining page and every other URL parameter is intentional.
   owner.applyViewMode(view,true);
   if(typeof owner.refresh==='function')window.setTimeout(function(){owner.refresh(document);},0);
 },true);
})();